export const StoreType = {
    TwoS: '2S',
    ThreeS: '3S',
    ClosedDeposit: 'Depósito Fechado',
    CompleteDealership: 'Concessionaria Completa',
    CompleteDealershipPro: 'Concessionaria Completa + PRO+',
    Pro: 'Pro+',
    RenaultMinuto: 'Renault Minuto',
    RMSN: 'RM + SN',
    RMSR: 'RM + SR',
    SemiNew: 'Seminovos',
    Showroom: 'Show Room',
    ShowroomPro: 'Show Room + PRO+',
    Service: 'Oficina',
    ServicePro: 'Oficina + PRO+'
};

export const StoreTypeEnum = {
    ConcessionariaCompleta: 1,
    Showroom: 2,
    Oficina: 3,
};

export const StoreExportTypeEnum = {
    Dealerships: 1,
    Competitors: 2,
    StoreInactive: 3,
    UnapprovedStores: 5,
};


// WEBPACK FOOTER //
// ./src/enuns/store.enun.js